// N-15b: 「この設定で届く人」を種類ごとに表示する。判定は shared の `selectRecipientsForKind`
// = functions の宛先解決と同じ純関数（画面は届くと言うのに実際は届かない、を作らない）。

import {
  ADMIN_NOTIFICATION_KINDS,
  ADMIN_NOTIFICATION_KIND_LABELS,
  selectRecipientsForKind,
  type NotificationRecipient,
} from '@kawai/shared';

export interface RecipientsPreviewProps {
  recipients: ReadonlyArray<NotificationRecipient>;
}

export function RecipientsPreview({ recipients }: RecipientsPreviewProps) {
  const nameByEmail = new Map<string, string>();
  const nameByLine = new Map<string, string>();
  for (const r of recipients) {
    if (r.email) nameByEmail.set(r.email.toLowerCase(), r.name);
    if (r.lineUserId) nameByLine.set(r.lineUserId, r.name);
  }
  return (
    <dl className="grid content-start gap-3 sm:grid-cols-2" data-testid="recipients-preview">
      {ADMIN_NOTIFICATION_KINDS.map((kind) => {
        const sel = selectRecipientsForKind({ recipients: [...recipients] }, kind);
        const emails = sel.emails.map((e) => nameByEmail.get(e.toLowerCase()) ?? e);
        const lines = sel.lineUserIds.map((id) => nameByLine.get(id) ?? id);
        return (
          <div key={kind} className="rounded-[10px] bg-surface-2 px-[22px] py-5">
            <dt className="text-label font-medium text-ink-2">
              {ADMIN_NOTIFICATION_KIND_LABELS[kind]}
            </dt>
            <dd className="mt-1.5 text-body text-ink">
              <div>
                <span className="text-label text-ink-3">メール: </span>
                {emails.length ? (
                  emails.join('、')
                ) : (
                  <span className="text-warning-ink">誰にも届きません</span>
                )}
              </div>
              <div>
                <span className="text-label text-ink-3">LINE: </span>
                {lines.length ? (
                  lines.join('、')
                ) : (
                  <span className="text-warning-ink">誰にも届きません</span>
                )}
              </div>
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
